import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import ioClient, { Socket } from 'socket.io-client'

import App from './App.vue'
import router from './router'
import axios from 'axios'
import store from './store'
import vuetify from './plugins/vuetify'
import ChartPlugin from './plugins/charts'

import BackButton from './domains/global/components/BackButton.vue'
import NotImplemented from './domains/global/components/NotImplemented.vue'
import AppLabel from './domains/global/components/Label.vue'
import SectionHeader from './domains/global/components/SectionHeader.vue'
import SmallHeader from './domains/global/components/SmallHeader.vue'
import Header from './domains/global/components/Header.vue'
import ConfirmModal from './domains/global/components/ConfirmModal.vue'
import SimpleError from './domains/global/components/SimpleError.vue'
import ExpandableImage from './domains/global/components/ExpandableImage.vue'
import AccordionCard from './domains/global/components/AccordionCard.vue'
import AppChart from './domains/global/components/AppChart.vue'
import AppPasswordInput from './domains/global/components/PasswordInput.vue'
import { centDisplay, dollarDisplay, formatBytes, prettyDate, prettyDateTime, prettyTime, shortDate } from './domains/global/functions/util'
import { consumeError } from './domains/global/utils'
import { configSetup } from './config-setup'
import { authAxios } from './domains/auth/utils'
import { DefaultEventsMap } from '@socket.io/component-emitter'

ChartPlugin.register()

Vue.config.productionTip = false

Vue.filter('capitalize', function(value: string) {
  if (!value) { return '' }
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('dollarDisplay', dollarDisplay)
Vue.filter('centDisplay', centDisplay)
Vue.filter('prettyDate', prettyDate)
Vue.filter('prettyTime', prettyTime)
Vue.filter('prettyDateTime', prettyDateTime)
Vue.filter('shortDate', shortDate)
Vue.filter('formatBytes', formatBytes)

Vue.component('AppBackBtn', BackButton)
Vue.component('NotImplemented', NotImplemented)
Vue.component('AppLabel', AppLabel)
Vue.component('SmallHeader', SmallHeader)
Vue.component('SectionHeader', SectionHeader)
Vue.component('AppHeader', Header)
Vue.component('ConfirmModal', ConfirmModal)
Vue.component('SimpleError', SimpleError)
Vue.component('ExpandableImage', ExpandableImage)
Vue.component('AppChart', AppChart)
Vue.component('AppPasswordInput', AppPasswordInput)
Vue.component('AccordionCard', AccordionCard)

Vue.mixin({
  methods: {
    formatError(error) {
      return consumeError(error)
    },
    handleError(error) {
      const formattedError = consumeError(error)
      if (formattedError.code !== 'SENTRY') {
        this.$store.dispatch('error', formattedError.message)
      } else {
        Sentry.captureException(error)
      }
    }
  }
})

let socketInstance: Socket<DefaultEventsMap, DefaultEventsMap>

configSetup().then((config) => {
  if (config.sentryDsn) {
    Sentry.init({
      Vue,
      environment: process.env.NODE_ENV === 'production' ? 'production' : 'development',
      dsn: config.sentryDsn,
      integrations: [new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router)
      })],
      tracesSampleRate: 1.0
    })
  }

  // @ts-ignore
  window.config = config

  axios.defaults.baseURL = `${config.apiUrl}/agency`
  axios.defaults.withCredentials = true

  authAxios.defaults.baseURL = config.authApiUrl

  store.commit('config/update', config)

  const path = new URL(`${config.websocketUrl}/socket.io`)
  socketInstance = ioClient(path.origin, { path: path.pathname, query: { type: 'agency' }, autoConnect: false, withCredentials: true })

  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
})

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  // if (error.response.status === 401) {
  //   store.dispatch('auth/expire')
  //   router.push('/login')
  // }
  return Promise.reject(error)
})

export const socket = () => {
  return socketInstance
}

Vue.prototype.$socket = socket
